import type { BoxReferenceInputOption } from "../BoxReferenceInput";

export function normalizeBoxReferenceText(value: string): string {
  return value.trim().toLocaleLowerCase("ru-RU");
}

export function findSelectedBoxReferenceOption(
  options: BoxReferenceInputOption[],
  value: string,
): BoxReferenceInputOption | undefined {
  const normalizedValue = normalizeBoxReferenceText(value);

  if (!normalizedValue) {
    return undefined;
  }

  return options.find((option) => {
    return (
      normalizeBoxReferenceText(option.label) === normalizedValue ||
      normalizeBoxReferenceText(option.id) === normalizedValue
    );
  });
}

export function filterBoxReferenceOptions(
  options: BoxReferenceInputOption[],
  searchValue: string,
): BoxReferenceInputOption[] {
  const query = normalizeBoxReferenceText(searchValue);

  if (!query) {
    return options;
  }

  return options.filter((option) => {
    return (
      normalizeBoxReferenceText(option.label).includes(query) ||
      normalizeBoxReferenceText(option.id).includes(query)
    );
  });
}

export function isBoxReferenceOptionSelected(
  option: BoxReferenceInputOption,
  value: string,
): boolean {
  const normalizedValue = normalizeBoxReferenceText(value);

  if (!normalizedValue) {
    return false;
  }

  return (
    normalizeBoxReferenceText(option.label) === normalizedValue ||
    normalizeBoxReferenceText(option.id) === normalizedValue
  );
}

export function getBoxReferenceEmptyStateText(args: {
  isLoading: boolean;
  optionsCount: number;
}): string {
  if (args.isLoading) {
    return "Загружаем коробки...";
  }

  return args.optionsCount === 0 ? "Коробок пока нет." : "Ничего не найдено.";
}

export function getBoxReferenceCountLabel(args: {
  isLoading: boolean;
  searchValue: string;
  optionsCount: number;
  filteredCount: number;
}): string {
  if (args.isLoading) {
    return "Загрузка";
  }

  if (!normalizeBoxReferenceText(args.searchValue)) {
    return `${args.optionsCount} всего`;
  }

  return `${args.filteredCount} найдено`;
}
